import { render, staticRenderFns } from "./process-reports-locked.vue?vue&type=template&id=36e8418d&scoped=true&"
import script from "./process-reports-locked.vue?vue&type=script&lang=ts&"
export * from "./process-reports-locked.vue?vue&type=script&lang=ts&"
import style0 from "./process-reports-locked.vue?vue&type=style&index=0&id=36e8418d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e8418d",
  null
  
)

export default component.exports